export default __webpack_public_path__ + "media/design-system/icon/assets/brand/MD/calendar-ed4f5177914f336dd7155accaaed8510.svg";